import * as store from '@attain-apps/fe/web/main/lib/store'

import type * as me from '../../feature'

import { getActionsConfig } from './actions'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/** Owns app results for each requested zone. */
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  constructor(parent: me.Feature) {
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'ZoneApps',
      parent,
      selectors: () => new Selectors(this),
    })

    this.registerEffects(effects.executeGet())
  }
}
